import Layout from "../../components/Layout";
import Table from "../../components/Table";

export default function HostedPaymentPages() {
  return (
    <Layout metaTitle="Hosted Payment Pages">
      <Table
        url="/d/hpp/"
        formURL="/d/hpp/form/"
        tableName="Hosted Payment Page"
        tableDescription="Create a hosted payment page that contains a context for intents with minimal configuration."
      />
    </Layout>
  );
}

HostedPaymentPages.parentPath = "/hosted-payment-pages";
